import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	button: {
		margin: -5,
		padding: 5,
	},
	container: {},
});
